import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref for processed flag - set synchronously to prevent race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        setError('No session ID found');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        await processGoogleSession(sessionId);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        setError(err.response?.data?.detail || 'Authentication failed');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    processSession();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <div className="text-red-500 text-lg">{error}</div>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-[#D4AF37] animate-spin mx-auto mb-4" />
            <p className="text-zinc-400">Authenticating...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
